import React from "react";
import "./Footer.scss";
import logo from "../../Media/logo.png";
import {
  CONTACT_INFO,
  COMPANY_INFO,
  NAVIGATION_LINKS,
} from "../../utils/constants";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        {/* Logo and Marketing Gallery Section */}
        <div className="footer-column footer-logo">
          <div className="logo-pacific-garden">
            <img src={logo} alt={`${COMPANY_INFO.NAME} Logo`} />
          </div>
          <nav className="footer-nav">
            <h3>Marketing Gallery</h3>
            <a href={NAVIGATION_LINKS.NAVBAR}>{COMPANY_INFO.NAME}</a>
            <a href={NAVIGATION_LINKS.PRIVACY_POLICY}>Privacy Policy</a>
          </nav>
        </div>

        {/* Sitemap Navigation Section */}
        <div className="footer-column footer-sitemap">
          <h3>Sitemap</h3>
          <nav>
            <a href={NAVIGATION_LINKS.ABOUT}>About us</a>
            <a href={NAVIGATION_LINKS.PROMO}>Promo</a>
            <a href={NAVIGATION_LINKS.BISCHOFIA}>Cluster Bischofia</a>
            <a href={NAVIGATION_LINKS.CALAMUS}>Cluster Calamus</a>
            <a href={NAVIGATION_LINKS.DALBERGIA}>Cluster Dalbergia</a>
            <a href={NAVIGATION_LINKS.SURROUNDING}>Surrounding Area</a>
            <a href={NAVIGATION_LINKS.LOCATION}>Location</a>
          </nav>
        </div>

        {/* Contact Information Section */}
        <div className="footer-column footer-contact">
          <h3>Kontak Kami</h3>
          <address>
            <p>
              <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
              {CONTACT_INFO.ADDRESS}
            </p>
            <p>
              <i className="fas fa-phone-alt" aria-hidden="true"></i>
              {CONTACT_INFO.PHONE}
            </p>
          </address>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="footer-bottom">
        <div>{COMPANY_INFO.COPYRIGHT}</div>
        <div className="powered-by">{COMPANY_INFO.POWERED_BY}</div>
      </div>
    </footer>
  );
};

export default Footer;
